import React, { useState } from 'react';

const EditAccountModal = ({ isOpen, onClose, onEditAccount, account }) => {
    const [newBalance, setNewBalance] = useState(account?.balance || '0');
    const [newCreditLimit, setNewCreditLimit] = useState(account?.creditLimit || '');

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onEditAccount({ accountId: account.id, newBalance, newCreditLimit });
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-sm shadow-xl">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">Edit Account: {account.name}</h3>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium">{account.accountType === 'credit' ? 'Current Balance (Amount Owed)' : 'Current Balance'}</label>
                        <input type="number" step="0.01" value={newBalance} onChange={(e) => setNewBalance(e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md" required />
                    </div>
                    {account.accountType === 'credit' && (
                        <div>
                            <label className="block text-sm font-medium">Credit Limit</label>
                            <input type="number" step="0.01" value={newCreditLimit} onChange={(e) => setNewCreditLimit(e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md" required />
                        </div>
                    )}
                    <div className="flex justify-end space-x-3 pt-2">
                        <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 rounded-md">Cancel</button>
                        <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-md">Save Changes</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditAccountModal;
